import { httpRequest } from "@services/http";

export interface JourneyStepSearchResult {
  id: number;
  name: string;
  journey_id: number;
  journey_name: string;
  industry: string | null;
  parent_id: number | null;
  breadcrumb: string[];
}

export class CommandSearchJourneySteps {
  async run(query: string): Promise<JourneyStepSearchResult[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/journeys/steps/search/?q=${encodeURIComponent(query)}`;
    return await httpRequest<JourneyStepSearchResult[]>(url, { method: "GET" });
  }
}
